export default "__VITE_ASSET__BBcZUct5__"